import { render, staticRenderFns } from "./signfor-logitics-statistical-list.vue?vue&type=template&id=4bbda168&scoped=true&"
import script from "./signfor-logitics-statistical-list.vue?vue&type=script&lang=ts&"
export * from "./signfor-logitics-statistical-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bbda168",
  null
  
)

export default component.exports